import * as Yup from 'yup';
import { TType } from '@translations/translationsTypes';

export const dataSubjectRightFormValidationScheme = (t: TType) => {
  return Yup.object()
    .shape({
      name: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(60, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      email: Yup.string()
        .matches(
          /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t('global.error.email')
        )
        .max(40, t('global.error.email'))
        .required(t('global.error.required')),
      phoneNumber: Yup.string()
        .min(10, t('global.error.globalPhone.min'))
        .max(15, t('global.error.globalPhone.max'))
        .matches(/^\d+$/, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      currentAddress: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(100, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      locationId: Yup.string().when('dsrOwnId', {
        is: 'YES',
        then: Yup.string().required(t('global.error.required')),
        otherwise: Yup.string(),
      }),
      dsrRelationshipId: Yup.string().when('dsrOwnId', {
        is: 'NO',
        then: Yup.string().required(t('global.error.required')),
        otherwise: Yup.string(),
      }),
      otherDsrRelationship: Yup.string()
        .when('dsrRelationshipId', {
          is: 'OTHERS',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(2, t('global.error.invalidInput'))
        .max(25, t('global.error.invalidInput')),
      relationshipWithTAWALId: Yup.string().when('dsrOwnId', {
        is: 'YES',
        then: Yup.string().required(t('global.error.required')),
        otherwise: Yup.string(),
      }),
      otherRelationshipWithTAWAL: Yup.string()
        .when('relationshipWithTAWALId', {
          is: 'OTHER',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(2, t('global.error.invalidInput'))
        .max(25, t('global.error.invalidInput')),
      requestTypeId: Yup.string().required(t('global.error.required')),
      accessDetails: Yup.string()
        .when('requestTypeId', {
          is: 'ACCESS',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(3, t('global.error.invalidInput'))
        .max(120, t('global.error.invalidInput')),
      correctionDetails: Yup.string()
        .when('requestTypeId', {
          is: 'CORRECTION',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(3, t('global.error.invalidInput'))
        .max(120, t('global.error.invalidInput')),
      destructionDetails: Yup.string()
        .when('requestTypeId', {
          is: 'DESTRUCTION',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(3, t('global.error.invalidInput'))
        .max(120, t('global.error.invalidInput')),
      informDetails: Yup.string()
        .when('requestTypeId', {
          is: 'INFORM',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(3, t('global.error.invalidInput'))
        .max(120, t('global.error.invalidInput')),
      identityFileContent: Yup.mixed().required(t('global.error.required')),
      obtainCopyDetails: Yup.string()
        .when('requestTypeId', {
          is: 'OBTAIN_COPY',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(3, t('global.error.invalidInput'))
        .max(120, t('global.error.invalidInput')),
      receiveInfoId: Yup.string().when('requestTypeId', {
        is: 'OBTAIN_COPY',
        then: Yup.string().required(t('global.error.required')),
        otherwise: Yup.string(),
      }),
      withdrawConsentDetails: Yup.string()
        .when('requestTypeId', {
          is: 'WITHDRAW',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(3, t('global.error.invalidInput'))
        .max(120, t('global.error.invalidInput')),
      userVerificationId: Yup.string().required(t('global.error.required')),
      nationalityId: Yup.string().required(t('global.error.required')),
      verificationEmail: Yup.string()
        .when('userVerificationId', {
          is: 'EMAIL',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .matches(
          /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t('global.error.email')
        )
        .max(40, t('global.error.email')),
      verificationPhoneNumber: Yup.string()
        .when('userVerificationId', {
          is: 'PHONE',
          then: Yup.string().required(t('global.error.required')),
          otherwise: Yup.string(),
        })
        .min(10, t('global.error.saudiPhone'))
        .max(10, t('global.error.saudiPhone'))
        .matches(/^05\d{8}$/, t('global.error.saudiPhone')),
      recaptchaToken: Yup.string().required(t('global.error.required')),
      termsOfUse: Yup.bool().equals([true], t('global.error.required')),
      privacyNotice: Yup.bool().equals([true], t('global.error.required')),
    })
    .nullable();
};
